// // import React, { useEffect } from 'react'
// // import { Drawer, Card, Button, Form, Row, Col } from 'antd'
// // import { useDispatch } from 'react-redux'
// // import moment from 'moment'
// // import { chooseEmailModalFxn, formItemLayout } from '../../../../components/_utils/appUtils'
// // import GetEachFormFields from '../../../../components/_utils/appFormUtils'
// // import { commentToAbstractAuthor } from '../actions'
// //
// // const CommentsToAbstractDrawer = (props) => {
// //   let {
// //     visible,
// //     onClose,
// //     form: { getFieldDecorator, setFieldsValue },
// //     callback = null,
// //     abstractId,
// //     abstract,
// //     edit
// //   } = props
// //   const dispatch = useDispatch()
// //
// //   const setFormData = () => {
// //     // Set default date to today
// //     setTimeout(() => {
// //       setFieldsValue({
// //         sendToAuthorDate: moment()
// //       })
// //     }, 100)
// //   }
// //
// //   useEffect(() => {
// //     setFormData()
// //   }, [])
// //
// //   const inputSchema = {
// //     fields: [
// //       {
// //         label: 'Date',
// //         key: 'sendToAuthorDate',
// //         required: true,
// //         placeholder: 'Date of Enter',
// //         type: 'date',
// //         span: 24
// //       },
// //       {
// //         key: 'statusType',
// //         label: 'Status Type',
// //         type: 'radioGroup',
// //         required: true,
// //         span: 24,
// //         options: ['Comments', 'Rejection']
// //       }
// //     ]
// //   }
// //
// //   const handleSubmit = e => {
// //     e.preventDefault()
// //     props.form.validateFieldsAndScroll(async (err, valData) => {
// //       if (!err) {
// //         chooseEmailModalFxn({
// //           title: 'Send Comments to Abstract Author',
// //           callback: async (email) => {
// //             valData.abstractId = abstractId
// //             valData.fromEmail = email
// //             // Dispatch the abstract-specific action
// //             let { success } = await dispatch(commentToAbstractAuthor(valData))
// //             if (success) {
// //               dispatch({ type: 'START_LOAD_ABSTRACTS' })
// //               onClose()
// //               if (callback) callback()
// //             }
// //           }
// //         })
// //       }
// //     })
// //   }
// //
// //   return (
// //     <Drawer
// //       title={`Comments To Author | ID: ${abstract.onlineAbstractId || 'N/A'}`}
// //       width={'40%'}
// //       visible={visible}
// //       placement='right'
// //       onClose={onClose}>
// //       <Card>
// //         <Form onSubmit={handleSubmit} hideRequiredMark className={'inputForm'}>
// //           <Row gutter={16}>
// //             {inputSchema.fields.map((item, key) => (
// //               <Col span={item.span || 8} key={key}>
// //                 <GetEachFormFields getFieldDecorator={getFieldDecorator} item={item} formItemLayout={formItemLayout} />
// //               </Col>
// //             ))}
// //             <Col span={24}>
// //               <Form.Item style={{ marginTop: 40 }}>
// //                 <Button type='primary' htmlType='submit'>Submit</Button>
// //               </Form.Item>
// //             </Col>
// //           </Row>
// //         </Form>
// //       </Card>
// //     </Drawer>
// //   )
// // }
// //
// // const WrappedForm = Form.create()(CommentsToAbstractDrawer)
// // export default WrappedForm
//
//
// import React, { useEffect } from 'react'
// import { Drawer, Card, Button, Form, Row, Col, Radio } from 'antd' // Added Radio
// import { useDispatch } from 'react-redux'
// import moment from 'moment'
// import { chooseEmailModalFxn, formItemLayout } from '../../../../components/_utils/appUtils'
// import GetEachFormFields from '../../../../components/_utils/appFormUtils'
// import { commentToAbstractAuthor } from '../actions'
//
// const CommentsToAbstractDrawer = (props) => {
//   let {
//     visible,
//     onClose,
//     form: { getFieldDecorator, setFieldsValue },
//     callback = null,
//     abstractId,
//     abstract,
//     edit
//   } = props
//   const dispatch = useDispatch()
//
//   const setFormData = () => {
//     // Set default date to today
//     setTimeout(() => {
//       setFieldsValue({
//         sendToAuthorDate: moment()
//       })
//     }, 100)
//   }
//
//   useEffect(() => {
//     setFormData()
//   }, [])
//
//   const inputSchema = {
//     fields: [
//       {
//         label: 'Date',
//         key: 'sendToAuthorDate',
//         required: true,
//         placeholder: 'Date of Enter',
//         type: 'date',
//         span: 24
//       },
//       {
//         key: 'statusType',
//         label: 'Status Type',
//         type: 'radioGroup',
//         required: true,
//         span: 24,
//         options: ['Comments', 'Rejection'],
//         onChange: x => {
//           setFieldsValue({
//             statusType: x.target.value
//           })
//         }
//       }
//     ]
//   }
//
//   const handleSubmit = e => {
//     e.preventDefault()
//     props.form.validateFieldsAndScroll(async (err, valData) => {
//       if (!err) {
//         chooseEmailModalFxn({
//           title: 'Send Comments to Abstract Author',
//           callback: async (email) => {
//             valData.abstractId = abstractId
//             valData.fromEmail = email
//             let { success } = await dispatch(commentToAbstractAuthor(valData))
//             if (success) {
//               // Resetting fields after successful submission
//               setFieldsValue({
//                 statusType: '',
//                 sendToAuthorDate: moment()
//               })
//               dispatch({ type: 'START_LOAD_ABSTRACTS' })
//               onClose()
//               if (callback) callback()
//             }
//           }
//         })
//       }
//     })
//   }
//
//   return (
//     <Drawer
//       title={`Comments To Author | ID: ${abstract.onlineAbstractId || 'N/A'}`}
//       width={'40%'}
//       visible={visible}
//       placement='right'
//       onClose={onClose}>
//       <Card>
//         <Form onSubmit={handleSubmit} hideRequiredMark className={'inputForm'}>
//           <Row gutter={16}>
//             {inputSchema.fields.map((item, key) => (
//               <Col span={item.span || 8} key={key}>
//                 <GetEachFormFields
//                   getFieldDecorator={getFieldDecorator}
//                   item={item}
//                   formItemLayout={formItemLayout}
//                 />
//               </Col>
//             ))}
//             <Col span={24}>
//               <Form.Item style={{ marginTop: 40 }}>
//                 <Button type='primary' htmlType='submit'>Submit</Button>
//               </Form.Item>
//             </Col>
//           </Row>
//         </Form>
//       </Card>
//     </Drawer>
//   )
// }
//
// const WrappedForm = Form.create()(CommentsToAbstractDrawer)
// export default WrappedForm



import React, { useEffect } from 'react'
import { Drawer, Card, Button, Form, Row, Col } from 'antd'
import { useDispatch } from 'react-redux'
import moment from 'moment'
import { chooseEmailModalFxn, formItemLayout } from '../../../../components/_utils/appUtils'
import GetEachFormFields from '../../../../components/_utils/appFormUtils'
import { commentToAbstractAuthor } from '../actions'

const CommentsToAbstractDrawer = (props) => {
  let {
    visible,
    onClose,
    form: { getFieldDecorator, setFieldsValue },
    callback = null,
    abstractId,
    abstract
  } = props
  const dispatch = useDispatch()

  // useEffect(() => {
  //   // Reset date when drawer opens
  //   if (visible) {
  //     setFieldsValue({
  //       sendToAuthorDate: moment()
  //     })
  //   }
  // }, [visible])
  useEffect(() => {
    if (visible) {
      setTimeout(() => {
        setFieldsValue({
          sendToAuthorDate: moment()
        });
      }, 50);
    }
  }, [visible, setFieldsValue]);

  const inputSchema = {
    fields: [
      {
        label: 'Date',
        key: 'sendToAuthorDate',
        required: true,
        placeholder: 'Date',
        type: 'date',
        span: 24
      }
    ]
  }

  const handleSubmit = e => {
    e.preventDefault()
    props.form.validateFieldsAndScroll(async (err, valData) => {
      if (!err) {
        chooseEmailModalFxn({
          title: 'Send Comments to Abstract Author',
          callback: async (email) => {
            valData.abstractId = abstractId
            valData.fromEmail = email
            // Force status to 'Comments' internally
            valData.statusType = 'Comments'

            let { success } = await dispatch(commentToAbstractAuthor(valData))
            if (success) {
              dispatch({ type: 'START_LOAD_ABSTRACTS' })
              onClose()
              if (callback) callback()
            }
          }
        })
      }
    })
  }

  return (
    <Drawer
      title={`Comments To Author | ID: ${abstract.onlineAbstractId || 'N/A'}`}
      width={'40%'}
      visible={visible}
      placement='right'
      onClose={onClose}>
      <Card>
        <Form onSubmit={handleSubmit} hideRequiredMark className={'inputForm'}>
          <Row gutter={16}>
            {inputSchema.fields.map((item, key) => (
              <Col span={item.span || 8} key={key}>
                <GetEachFormFields
                  getFieldDecorator={getFieldDecorator}
                  item={item}
                  formItemLayout={formItemLayout}
                />
              </Col>
            ))}
            <Col span={24}>
              <Form.Item style={{ marginTop: 40 }}>
                <Button type='primary' htmlType='submit'>Submit Comments</Button>
              </Form.Item>
            </Col>
          </Row>
        </Form>
      </Card>
    </Drawer>
  )
}

const WrappedForm = Form.create()(CommentsToAbstractDrawer)
export default WrappedForm
